export default __webpack_public_path__ + "static/media/Arrow3.6206e762.svg";